import React from 'react';
import {
  Anchor,
  Card,
  Collapsible,
  CollapsibleContent,
  CollapsiblePanel,
  Heading,
} from '@americanexpress/dls-react';

const faqItems = [
  {
    id: 'faq-status',
    question: 'How do I find out the status of my application?',
    answer: (
      <p className="body-2 mar-0">
        You can get a decision for your online application in just minutes. For
        the status of an American Express Card application that cannot be
        evaluated instantly, click{' '}
        <Anchor href="#application-status-search" inline={true}>
          here
        </Anchor>{' '}
        to go to our online status site, or call New Accounts at{' '}
        <Anchor href="tel:18888263471" inline={true}>
          1-888-826-3471
        </Anchor>{' '}
        (Mon-Fri 6am-9pm MST) to check the status of your application by phone.
      </p>
    ),
  },
  {
    id: 'faq-phone-apply',
    question: 'Can I apply over the phone?',
    answer: (
      <p className="body-2 mar-0">
        Yes, call{' '}
        <Anchor href="tel:18002433888" inline={true}>
          1-800-243-3888
        </Anchor>
        . Please note: If you are applying for a special offer through an email
        or online promotion, you must apply through the special URL link
        provided in the solicitation or website to receive the bonus.
      </p>
    ),
  },
  {
    id: 'faq-customer-care',
    question: 'Can I speak with a Customer Care Professional before I apply?',
    answer: (
      <p className="body-2 mar-0">
        Yes, call{' '}
        <Anchor href="tel:18002433888" inline={true}>
          1-800-243-3888
        </Anchor>
        . Please note: Customer service representatives cannot enroll you in
        special offers via phone. If you are applying for a special offer
        through an email or online promotion, you must apply through the special
        URL link provided in the solicitation or website to receive the bonus.
      </p>
    ),
  },
  {
    id: 'faq-needed-info',
    question: 'What information do I need to complete this application?',
    answer: (
      <>
        <p className="body-2 mar-0 mar-2-b">
          If you are applying for a personal Card, you will need the following
          information in addition to your name and residence.
        </p>
        <ul className="mar-0 pad-0-l pad-2-l">
          <li className="body-2 mar-1-b">Your social security number</li>
          <li className="body-2 mar-1-b">A valid email address</li>
          <li className="body-2 mar-1-b">A valid phone number</li>
          <li className="body-2 mar-0">
            The full name of anyone you wish to add to your account or give an
            Additional Card to
          </li>
        </ul>
      </>
    ),
  },
];

const FaqsSections = () => (
  <section className="pad-4-t" aria-labelledby="faq-heading">
    <Card type="standard" showAccentBar={true}>
      <div className="pad-3">
        <Heading
          id="faq-heading"
          level={2}
          headingStyle="heading5"
          className="mar-0 mar-2-b"
        >
          Frequently Asked Questions
        </Heading>
        <Collapsible defaultOpen={[faqItems[0].id]}>
          {faqItems.map(({ id, question, answer }) => (
            <React.Fragment key={id}>
              <CollapsiblePanel id={id} headingLevel={3}>
                <span className="body-1">{question}</span>
              </CollapsiblePanel>
              <CollapsibleContent labelledBy={id}>
                <div className="pad-2">{answer}</div>
              </CollapsibleContent>
            </React.Fragment>
          ))}
        </Collapsible>
      </div>
    </Card>
  </section>
);

export default FaqsSections;
